import { render, staticRenderFns } from "./LargeActivitgoodsList.vue?vue&type=template&id=fab91840&"
import script from "./LargeActivitgoodsList.vue?vue&type=script&lang=js&"
export * from "./LargeActivitgoodsList.vue?vue&type=script&lang=js&"
import style0 from "./LargeActivitgoodsList.vue?vue&type=style&index=0&id=fab91840&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fab91840')) {
      api.createRecord('fab91840', component.options)
    } else {
      api.reload('fab91840', component.options)
    }
    module.hot.accept("./LargeActivitgoodsList.vue?vue&type=template&id=fab91840&", function () {
      api.rerender('fab91840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/LargeActivitgoodsList.vue"
export default component.exports